import { SectionSlot } from '@youshift/shared/types';
import {
  dateToString,
  getDifferenceInColumns,
  getDifferenceInMinutes,
  getShadeForLabels,
  localeNormalizer,
  Spanning,
} from '@youshift/shared/utils';

import { ArrangedSectionSlot } from '../../../pages/Manager/IterationConfig/Sections/types';
import i18n from '../../../utils/i18n';

function isArrangedSectionSlot(
  slot:
    | (SectionSlot & {
        spanning: Spanning;
      } & {
        start: Date;
        end: Date;
      })
    | ArrangedSectionSlot,
): slot is ArrangedSectionSlot {
  return 'start_position' in slot && 'end_position' in slot;
}

export const getArrangedSectionSlot = (
  slot:
    | (SectionSlot & {
        spanning: Spanning;
      } & {
        start: Date;
        end: Date;
      })
    | ArrangedSectionSlot,
  week: Date[] | undefined,
): ArrangedSectionSlot => {
  if (isArrangedSectionSlot(slot) || !week) {
    return slot as ArrangedSectionSlot;
  }
  const locale = localeNormalizer(i18n.language);
  const diffFromStart = getDifferenceInColumns(week[0], slot.start);
  const duration = getDifferenceInColumns(slot.start, slot.end);

  const { id_pref_slot, rest_period, slot_labels, id_section_slot, spanning } =
    slot;

  return {
    custom_counter_increments: slot.custom_counter_increments,
    start_position: diffFromStart === 0 ? diffFromStart + 1 : diffFromStart,
    end_position: diffFromStart + duration,
    start_time: dateToString(slot.start, 'hh:mm', locale),
    end_time: dateToString(slot.end, 'hh:mm', locale),
    duration_minutes: getDifferenceInMinutes(slot.start, slot.end),
    id_pref_slot,
    rest_period,
    slot_labels,
    id_section_slot,
    spanning,
  };
};
